module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1",
    attrs: {
      "id": "epig"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Fact")]), _vm._v(": The most important relic in Christendom is hiding in plain sight in a monastery church of the Cappucine friars outside the small village of Manoppello, Italy.")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Fact")]), _vm._v(": The House of the Virgin Mary—where evidence suggests that Jesus’ mother lived out her final years—is located in a Muslim country.")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Fact:")]), _vm._v(" The Virgin Mary, venerated by most Muslims, is the only woman mentioned by name in the Koran, is only one of eight people to have a chapter named for them in the Koran, and is mentioned more often in the Koran than in the Bible.")]), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("Fact:")]), _vm._v(" In 1209, Pope Innocent III initiated the Albigensian Crusade—and with it the Papal Inquisition—to wipe out the Cathar faith, the fastest-growing “heretical” Christian sect in Europe. Although estimates vary widely, the death toll from that Crusade is estimated to be 200,000–1,000,000.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 75
// module chunks = 0